document.addEventListener("alpine:init", () => {
    Alpine.data("tabbedHeadingBlock", () => ({
        open: false,
        height: 0,
        checkbox: null,
        top: null,
        content: null,
        item: null,
        init() {
            this.checkbox = this.$el.querySelectorAll(
                "input[type='checkbox']",
            )[0];

            this.item = this.$el;

            this.top = this.item.querySelector(".Tab__Heading__Block__top");

            this.content = this.$el.querySelector(
                ".Tab__Heading__Block__content",
            );

            this.content.style.setProperty(
                "--max-height",
                this.content.scrollHeight * 2 + "px",
            );

            pegasus.onResizeFinished(() => {
                this.content.style.setProperty(
                    "--max-height",
                    this.content.scrollHeight * 2 + "px",
                );
            }, true);
        },
        checkOpen() {
            if (this.checkbox === undefined) {
                return;
            }

            if (this.checkbox.checked) {
                this.open = true;
            } else {
                this.open = false;
            }

            setTimeout(() => {
                //pegasus.scroll(this.top, -160);
            }, 30);
        },
    }));
});
